export const linkBg = '#e8eaee';
export const lightText = '#90949c';
export const headlineColor = '#1C2028';
export const descriptionColor = '#464950';
export const displayUrlColor = descriptionColor;
export const ctaColor = descriptionColor;
export const ctaBorder = '#444950';
export const darkText = '#1d2129';
export const headBg = '#fff';
